import { common_urls } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, switchMap, tap, Observable } from 'rxjs';
interface GenerateSessionTrxResponse {
  sessionTxnId: string;
}
interface surveyTransactionIdPayload {
  surveyType: string;
  touchPoint: string;
  sessionTxnId: string;
  subTouchPoint: string;
}
interface surveyTransactionIdResponse {
  txnId: string;
}

@Injectable({
  providedIn: 'root'
})
export class SessionTransactionService {
    private httpClient = inject(HttpClient);
    private oidcSecurityService = inject(OidcSecurityService);
    sessionTransactionId = "";
    GenerateSessionTrxResponse =  {
      sessionTxnId: ''
    };

  constructor() { }
//As part of VOC Implementation, we need to generate the session ID once the user navigates to angular page.
    generateSessionID() {
      const payload=  {
        "touchPoint": "CWS",
      }
    const apiEndpoint = `${common_urls.bffInternalUrl}/create-sessionId`;
    return this.oidcSecurityService
      .getAccessToken()
      .pipe(
        switchMap((accessToken) =>
          this.httpClient.post<GenerateSessionTrxResponse>(
            apiEndpoint,
            payload,
            this.getRequestOptions(accessToken))
        ),
        tap((response) => {
          this.sessionTransactionId = response.sessionTxnId;
        }),
        catchError((error) => {
          throw Error(error);
        })
      );
  }
//As part of VOC implementation, once the user submit the digital survey, we will call this API to get the transaction ID
  getSurveyTransactionId(payload: surveyTransactionIdPayload): Observable<surveyTransactionIdResponse> {
    const apiEndpoint = `${common_urls.bffInternalUrl}/create-transactionId`;
    return this.oidcSecurityService
      .getAccessToken()
      .pipe(
        switchMap((accessToken) =>
          this.httpClient.post<surveyTransactionIdResponse>(
            apiEndpoint,
            payload,
            this.getRequestOptions(accessToken))
        ),
        catchError((error) => {
          throw Error(error);
        })
      );
  }

   private getRequestOptions(accessToken: string): { headers: HttpHeaders } {
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${accessToken}`,
      }),
    };
  } 
}
